import { apiRequest } from "./client";

function queryString(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, value);
  });
  const text = query.toString();
  return text ? `?${text}` : "";
}

export const appointmentsApi = {
  list(projectId, params = {}) {
    return apiRequest(
      `/projects/${projectId}/appointments${queryString(params)}`,
    );
  },

  create(projectId, payload) {
    return apiRequest(`/projects/${projectId}/appointments`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  update(projectId, appointmentId, payload) {
    return apiRequest(
      `/projects/${projectId}/appointments/${appointmentId}`,
      {
        method: "PUT",
        body: JSON.stringify(payload),
      },
    );
  },

  getAvailability(projectId, serviceId) {
    return apiRequest(
      `/projects/${projectId}/appointments/availability/${serviceId}`,
    );
  },

  saveAvailability(projectId, serviceId, payload) {
    return apiRequest(
      `/projects/${projectId}/appointments/availability/${serviceId}`,
      {
        method: "PUT",
        body: JSON.stringify(payload),
      },
    );
  },

  listBlocks(projectId, params = {}) {
    return apiRequest(
      `/projects/${projectId}/appointments/calendar-blocks${queryString(params)}`,
    );
  },

  createBlock(projectId, payload) {
    return apiRequest(`/projects/${projectId}/appointments/calendar-blocks`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  removeBlock(projectId, blockId) {
    return apiRequest(
      `/projects/${projectId}/appointments/calendar-blocks/${blockId}`,
      { method: "DELETE" },
    );
  },
};
